import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Stinger } from "./stinger.models";

const initialState = {
  stingerList: {
    list: [] as Stinger[],
    count: 0,
    isLoading: false,
    isError: false,
  },
};

export const MediaSlice = createSlice({
  name: "mediaSlice",
  initialState,
  reducers: {
    setFetchingStingerList: (state, action) => {
      state.stingerList.isLoading = action.payload;
    },
    setStingerList: (state, action) => {
      state.stingerList.isLoading = false;
      state.stingerList.list = [...action.payload.list];
      state.stingerList.count = action.payload.count;
    },
  },
});

interface stingerListParams {
  filters: any;
  rows: number;
  page: number;
}

// creating actions from reducers
export const { setStingerList, setFetchingStingerList } = MediaSlice.actions;

export default MediaSlice.reducer;
